/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { ElectronBeamQualityDto } from './ElectronBeamQualityDto';
import {
    ElectronBeamQualityDtoFromJSON,
    ElectronBeamQualityDtoFromJSONTyped,
    ElectronBeamQualityDtoToJSON,
} from './ElectronBeamQualityDto';

/**
 * 
 * @export
 * @interface ElectronBeamQualitiesDto
 */
export interface ElectronBeamQualitiesDto {
    /**
     * 
     * @type {Array<ElectronBeamQualityDto>}
     * @memberof ElectronBeamQualitiesDto
     */
    values?: Array<ElectronBeamQualityDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ElectronBeamQualitiesDto
     */
    visible?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ElectronBeamQualitiesDto
     */
    radiationTypeLabel: string;
    /**
     * 
     * @type {string}
     * @memberof ElectronBeamQualitiesDto
     */
    energyLabel: string;
    /**
     * 
     * @type {string}
     * @memberof ElectronBeamQualitiesDto
     */
    highDoseTechniqueTypeLabel: string;
    /**
     * 
     * @type {string}
     * @memberof ElectronBeamQualitiesDto
     */
    $type?: ElectronBeamQualitiesDtoTypeEnum;
}


/**
 * @export
 */
export const ElectronBeamQualitiesDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedMedicalSystemComponentDtoTreatmentMachinesConfigurationElectronBeamQualitiesDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.TreatmentMachines.Configuration.ElectronBeamQualitiesDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ElectronBeamQualitiesDtoTypeEnum = typeof ElectronBeamQualitiesDtoTypeEnum[keyof typeof ElectronBeamQualitiesDtoTypeEnum];


/**
 * Check if a given object implements the ElectronBeamQualitiesDto interface.
 */
export function instanceOfElectronBeamQualitiesDto(value?: unknown): value is ElectronBeamQualitiesDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ElectronBeamQualitiesDtoTypeEnum)[0];
}

export function ElectronBeamQualitiesDtoFromJSON(json: any): ElectronBeamQualitiesDto {
    return ElectronBeamQualitiesDtoFromJSONTyped(json, false);
}

export function ElectronBeamQualitiesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ElectronBeamQualitiesDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'values': !exists(json, 'values') ? undefined : (json['values'] === null ? null : (json['values'] as Array<any>).map(ElectronBeamQualityDtoFromJSON)),
        'visible': !exists(json, 'visible') ? undefined : json['visible'],
        'radiationTypeLabel': json['radiationTypeLabel'],
        'energyLabel': json['energyLabel'],
        'highDoseTechniqueTypeLabel': json['highDoseTechniqueTypeLabel'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function ElectronBeamQualitiesDtoToJSON(value?: ElectronBeamQualitiesDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'values': value.values === undefined ? undefined : (value.values === null ? null : (value.values as Array<any>).map(ElectronBeamQualityDtoToJSON)),
        'visible': value.visible,
        'radiationTypeLabel': value.radiationTypeLabel,
        'energyLabel': value.energyLabel,
        'highDoseTechniqueTypeLabel': value.highDoseTechniqueTypeLabel,
        '$type': value.$type,
    });
}

